<span class="description">From: </span>
<div class="datetime-field-class date-pick">
  <mat-form-field>
    <input matInput [max]="dateTo || today" [(ngModel)]="dateFrom" name="dateTo"
           (focus)="pickerFrom.open()" (click)="pickerFrom.open()"
           [matDatepicker]="pickerFrom"
           placeholder="Choose a date"
           (ngModelChange)="dateFromChange.emit(dateFrom); change.emit()">
    <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
    <mat-datepicker #pickerFrom></mat-datepicker>
  </mat-form-field>
</div>

<span class="description">To: </span>
<div class="datetime-field-class date-pick">
  <mat-form-field>
    <input matInput [min]="dateFrom" [max]="today" [(ngModel)]="dateTo" name="dateTo"
           (focus)="pickerTo.open()" (click)="pickerTo.open()"
           [matDatepicker]="pickerTo"
           placeholder="Choose a date"
           (ngModelChange)="dateToChange.emit(dateTo); change.emit()">
    <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
    <mat-datepicker #pickerTo></mat-datepicker>
  </mat-form-field>
</div>



// WEBPACK FOOTER //
// /app/src/app/components/fields/date-interval-field/date-interval-field.component.html